// extracted by mini-css-extract-plugin
export default {"wrapper":"History_wrapper__uik1D","table":"History_table__AJBXA","row":"History_row__LDqrV","col":"History_col__9VNAS","status":"History_status__XqazZ"};